import React from 'react';
import _ from 'lodash';
import { daysAgo } from '../../common/SharedFunctions';
import store, { brokerActions } from '@apply/adminStore';
import { Accordion, SortableHeader } from '../../common/SharedComponents';
import { BrokerApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { useSelector } from 'react-redux';
import { RefreshEvents } from '../../common/SharedEvents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faClock } from '@fortawesome/free-regular-svg-icons';
import { faFlag } from '@fortawesome/free-solid-svg-icons';

const activeColumns = [
    { key: 'Status', label: 'Status', id: 'brokerStatus' },
    { key: 'Flgd', label: 'Flag', id: 'isFlagged' },
    { key: 'Name', label: 'Name' },
    { key: 'Email', label: 'Email', id: 'emailAddress' },
    { key: 'Modified', label: 'Modified', id: 'updatedAt' },
    {
        key: 'Point of Contact',
        label: 'Point of Contact',
        id: 'pointOfContact',
    },
];

const PendingBrokerTable = () => {
    const searchState = useSelector((state) => state.searchState);
    const brokerApi = new BrokerApi.BrokerApi(applicationInsights);

    const { dispatch } = store;

    const refreshEvents = new RefreshEvents();

    const [rows, set_rows] = React.useState([]);
    const [sort, set_sort] = React.useState({
        column: 'brokerStatus',
        direction: 'asc',
    });

    React.useEffect(() => {
        _loadBrokers();

        refreshEvents.addRefreshListener(_loadBrokers);
    }, []);

    const _handleRowClick = (row) => {
        dispatch(brokerActions.setBrokerId({ brokerId: row.id }));
        dispatch(brokerActions.setBrokerModalOpen({ openBrokerModal: true }));
    };

    const _handleReviewButton = (brokerId) => {
        dispatch(brokerActions.setBrokerId({ brokerId: brokerId }));
        dispatch(brokerActions.setBrokerModalOpen({ openBrokerModal: true }));
    };

    const _loadBrokers = async () => {
        const response = await brokerApi.getPendingBrokerGridRows();

        if (response.statusCode !== 200) return;

        set_rows(
            response.result.map((b) => ({
                ...b,
                name: b.lastName + ', ' + b.firstName,
                updatedDaysAgo: daysAgo(new Date(b.updatedAt)),
            }))
        );
    };

    const matchName = (s) => s.name && s.name.toLowerCase().includes(searchState.searchText.broker.toLowerCase());
    const matchEmail = (s) =>
        s.emailAddress && s.emailAddress.toLowerCase().includes(searchState.searchText.broker.toLowerCase());

    const sortedRows = _.chain(rows)
        .filter((s) => !searchState.searchText.broker || matchName(s) || matchEmail(s))
        .orderBy(sort.column, sort.direction)
        .value();

    return (
        <Accordion title='Broker Accepted Invite (waiting on BFI) '>
            <div className='card'>
                <div className='card-section'>
                    <table>
                        <thead>
                            <tr>
                                <th className='count' />
                                {activeColumns.map((col) => (
                                    <SortableHeader
                                        key={col.key}
                                        column={col}
                                        sort={sort}
                                        onPress={set_sort}
                                    />
                                ))}
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {sortedRows.map((row) => (
                                <tr key={row.id}>
                                    <td
                                        className='count'
                                        style={{ position: 'relative' }}
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        <span
                                            className='reddot'
                                            style={{ left: 12 }}
                                        >
                                            <span className='sr-only'>Needs attention</span>
                                        </span>
                                    </td>
                                    <td
                                        className='status'
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        <span className='icon-column'>
                                            <FontAwesomeIcon
                                                icon={faClock}
                                                className='icon'
                                            />{' '}
                                            Pending
                                        </span>
                                    </td>
                                    <td
                                        className='isFlagged'
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        {row.isFlagged && (
                                            <i
                                                style={{ color: 'darkred' }}
                                                title='Broker is Flagged!'
                                            >
                                                <FontAwesomeIcon icon={faFlag} />
                                            </i>
                                        )}
                                    </td>
                                    <td
                                        className='primary nameColumn'
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        {row.name}
                                    </td>
                                    <td
                                        className='emailColumn'
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        {row.emailAddress}
                                    </td>
                                    <td
                                        className='time-stamp'
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        {row.updatedDaysAgo}
                                    </td>
                                    <td onClick={() => _handleRowClick(row)}>{row.pointOfContact}</td>
                                    <td className='actions'>
                                        <button
                                            className='gridButton'
                                            onClick={() => _handleReviewButton(row.id)}
                                        >
                                            <FontAwesomeIcon icon={faEye} /> Review
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Accordion>
    );
};

export default PendingBrokerTable;
